// Função para adicionar (ou atualizar) dados no sessionStorage
export const setSessionStorageItem = (key, value) => {
    try {
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
      const event = new CustomEvent('sessionStorageChange', { detail: { key, value } });
      window.dispatchEvent(event);
    } catch (error) {
      console.error("Erro ao salvar no sessionStorage:", error);
    }
  };
  
  // Função para obter dados do sessionStorage
  export const getSessionStorageItem = (key) => {
    try {
      const serializedValue = sessionStorage.getItem(key);
      if (serializedValue === null) {
        return null; // Se não encontrar, retorna null
      }
      return JSON.parse(serializedValue);
    } catch (error) {
      console.error("Erro ao obter do sessionStorage:", error);
      return null;
    }
  };
  
  // Função para limpar (remover) um item específico do sessionStorage
  export const clearSessionStorageItem = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("Erro ao limpar item do sessionStorage:", error);
    }
  };
  
  // Função para limpar todo o sessionStorage
  export const clearAllSessionStorage = () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error("Erro ao limpar todo o sessionStorage:", error);
    }
  };
  